import { FilterInputValue } from "@/types/common";

export const getFilterCount = (
    selectedFilters: Record<string, FilterInputValue>,
) =>
    Object.values(selectedFilters).reduce(
        (sum: number, vals) => sum + (Array.isArray(vals) ? vals.length : 0),
        0,
    );
